import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import * as CryptoJS from 'crypto-js';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IndiceReajusteModel } from 'app/model/cliente/indicereajuste.model';
import { IndicereajusteService } from 'app/service/cliente/indicereajuste.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-indicereajuste',
  templateUrl: './indicereajuste.component.html',
  styleUrls: ['./indicereajuste.component.scss']
})
export class IndicereajusteComponent implements OnInit {

  @ViewChild('cardEdit') targetEl: ElementRef;
  @ViewChild('indiceReajusteInput') indiceReajusteInput: ElementRef;
  public page: ResponsePageable;

  public submit = false;
  public loading = true;

  indiceReajuste = {} as IndiceReajusteModel;
  indiceReajustes: IndiceReajusteModel[];

  public pageAtual = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  public arrayString: string;
  public creatorIndiceReajuste = false;
  public editorIndiceReajuste = false;
  public listarIndiceReajuste = false;
  public deletaIndiceReajuste = false;
  public superUser = false;

  constructor(private indiceReajusteService: IndicereajusteService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService) { }

  ngOnInit() {
    this.listarPageIndiceReajuste(0, 10);
    this.getAuthority();
  }

  listarIndicesReajuste(){
    this.indiceReajusteService.getIndicesReajuste().subscribe(data =>{
      this.indiceReajustes = data.content;
    })
  }

  listarPageIndiceReajuste(page, size){
    this.indiceReajusteService.getPageIndiceReajuste(page, size).subscribe(res => {
      this.page = res;
      this.indiceReajustes = this.page.content;
      this.loading = false;
    });
  }

  changePage(event){
    this.listarPageIndiceReajuste(event.page, event.size);
    this.pageAtual = event.page;
   }

  onSubmit(){
    this.submit = true;
  }

  postSubmit(){
    this.submit = false;
    this.indiceReajusteInput.nativeElement.value = '';
    this.indiceReajuste.indice = null;
  }

  saveOrEdit() {
    if (this.indiceReajuste.id !== undefined) {
      this.putIndiceReajuste();
    } else {
      this.cadastrarIndiceReajuste();
    }
  }

  cadastrarIndiceReajuste() {
    this.indiceReajusteService.postIndiceReajuste(this.indiceReajuste).subscribe(indiceReajuste => {
        this.indiceReajuste = new IndiceReajusteModel();
        this.listarPageIndiceReajuste(0, 10);
        this.openSnackBarSuccess('Índice de Reajuste salvo com sucesso !');
        this.postSubmit();
    } , err => {
      console.log(err);
      this.openSnackBarError('Erro ao tentar salvar o Índice de Reajuste !');
    });
  }

  putIndiceReajuste() {
    this.indiceReajusteService.putIndiceReajuste(this.indiceReajuste).subscribe(() => {
      this.indiceReajuste = new IndiceReajusteModel();
      this.listarPageIndiceReajuste(this.pageAtual, 10);
      this.openSnackBarSuccess('Índice de Reajuste atualizado com sucesso !');
      this.postSubmit();
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar atualizar o Índice de Reajuste');
    });
  }

  editarIndiceReajuste(indiceReajuste: IndiceReajusteModel){
    this.indiceReajuste = { ...indiceReajuste}
  }

  confirmeExclusao(id: number){
    var confirme = confirm("Deseja excluir este indice de reajuste ?")
    if(confirme == true){
      this.deleteIndiceReajuste(id);
    } else {
      console.log("Cancelou exclusão!");
    }
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  deleteIndiceReajuste(id:number){
    this.indiceReajusteService.deleteIndiceReajuste(id).subscribe(indiceReajuste => {
        this.indiceReajuste = new IndiceReajusteModel();
        this.listarPageIndiceReajuste(0, 10);
        this.openSnackBarSuccess('Índice de Reajuste excluído com sucesso !');
    }, err => {
      if(err.status == 500){
        this.openSnackBarError('Erro ao excluir! Este indice de reajuste está sendo usado por um cliente.');
      }
      console.log('error', err.status);
    })

  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorIndiceReajuste = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorIndiceReajuste = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listarIndiceReajuste = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaIndiceReajuste = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }


// SnackBares
openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}

}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/indicereajuste/indicereajuste.component.ts